import { renderToStaticMarkup } from 'react-dom/server';

import parse, { domToReact } from 'html-react-parser';

import _ from 'lodash';
import lessonManager from '../managers/LessonManager';
import { Behavior } from './Behavior';

import { ContentType, LessonMode, PartialScoringType, QuestionFeedbackState } from '../../Constants';

import clozeMathService from '../services/ClozeMathService';
import clozeService from '../services/ClozeService';
import htmlService from '../services/HtmlService';
import promptService from '../services/PromptService';
import questionService from '../services/QuestionService';
import scoringService from '../services/ScoringService';
import utilsService from '../services/UtilsService';
import responseManager from '../managers/ResponseManager';

export class ClozeBehavior extends Behavior {
  getInitializedResponse = (lessonElementId, model) => {
    const userInputMap = new Map();
    if (model.type === ContentType.CLOZE.type ||
      model.type === ContentType.CLOZE_DRAG_DROP.type) {
      this._initTypingAndDragDrop(model, userInputMap);
    }

    if (model.type === ContentType.CLOZE_MULTICHOICE.type) {
      this._initMultiselect(model, userInputMap);
    }

    if (model.type === ContentType.CLOZE_COMBO.type) {
      this._initCombo(model, userInputMap);
    }

    if (model.type === ContentType.CLOZE_MATH.type) {
      this._initMath(model, userInputMap);
    }

    return {
      ...questionService.generateInitializedQuestionResponse({
        feedbackIconSvgHeight: '15',
        feedbackIconSvgWidth: '15',
        lessonElementId,
        multi: true,
        userInputMap
      })
    };

    /*
    if (Array.isArray(model?.validation?.prompts)) {
      for (const prompt of model?.validation?.prompts) {
        userInputMap.set(prompt.id, {
          dataId: prompt.id,
          text: ''
        });
      }
      return {
        ...questionService.generateInitializedQuestionResponse({
          lessonElementId,
          multi: true,
          userInputMap
        })
      };
    } else {
      return {
        ...questionService.generateInitializedQuestionResponse({
          feedbackIconSvgHeight: '15',
          feedbackIconSvgWidth: '15',
          lessonElementId,
          multi: true,
          userInputMap
        })
      };
    }

    */
  }

  _initTypingAndDragDrop = (model, userInputMap) => {
    model.prompts = [];

    const mathText = (model && !utilsService.isNullOrEmpty(model.mathText)) ? model.mathText : '';

    const polyfilledClozeBody = htmlService.getPolyfilledHtmlString((model?.body || mathText || ''));

    // eslint-disable-next-line no-unused-vars
    const parsedClozeBody = parse((polyfilledClozeBody || ''), {
      replace: (domNode) => {
        if (domNode.attribs?.['data-id']) {
          const dataId = domNode.attribs['data-id'];
          const rangeType = domNode.attribs['data-range-type'];
          userInputMap.set(dataId, {
            dataId,
            text: '',
            match: false
          });
          if (model.prompts && _.findIndex(model.prompts, { id: dataId }) < 0) {
            model.prompts.push({ id: dataId, text: '', rangeType });
          }
        }
      }
    });
  }

  _initMultiselect = (model, userInputMap) => {
    model.prompts = [];

    if (model.responseItems) {
      model.responseItems.forEach((item, index) => {
        userInputMap.set(item.promptId, {
          dataId: item.promptId,
          text: '',
          match: false
        });
        if (model.prompts && _.findIndex(model.prompts, { id: item.promptId }) < 0) {
          model.prompts.push({
            id: item.promptId,
            answers: item.responseOptions,
            dataId: item.promptId,
            text: '',
            match: false
          });
        }
      });
    }
  }

  _initCombo = (model, userInputMap) => {
    model.prompts = [];

    const mathText = (model && !utilsService.isNullOrEmpty(model.mathText)) ? model.mathText : '';
    const polyfilledClozeBody = htmlService.getPolyfilledHtmlString((model?.body || mathText || ''));

    // eslint-disable-next-line no-unused-vars
    const parsedClozeBody = parse((polyfilledClozeBody || ''), {
      replace: (domNode) => {
        if (domNode.attribs?.['data-id']) {
          const dataId = domNode.attribs['data-id'];
          const rangeType = domNode.attribs['data-range-type'];
          userInputMap.set(dataId, {
            dataId,
            text: '',
            match: false
          });

          if (model.prompts && _.findIndex(model.prompts, { id: dataId }) < 0) {
            if (rangeType === 'cloze') {
              model.prompts.push({
                id: dataId,
                text: '',
                match: false,
                rangeType
              });
            } else if (rangeType === 'clozeMultichoice') {
              if (model.responseItems) {
                const item = _.find(model.responseItems, { promptId: dataId });
                if (item) {
                  model.prompts.push({
                    id: item.promptId,
                    answers: item.responseOptions,
                    dataId: item.promptId,
                    text: '',
                    match: false,
                    rangeType,
                    multiSelect: !!item.multiSelect,
                    correctAnswerCount: item.correctAnswerCount
                  });
                }
              }
            }
          }
        }
      }
    });
  }

  _initMath = (model, userInputMap) => {
    if (model.prompts) {
      model.prompts.forEach((item, index) => {
        userInputMap.set(item.blankId, {
          dataId: item.blankId,
          text: '',
          match: false,
          answerType: item.answerType
        });
        item.id = item.blankId;
      });
    }
  }

  // TODO commented out so default tryAgainButtonHandler will be used.
  // tryAgainButtonHandler = async ({
  //   /* event, lessonElementId, */
  //   lessonElementState, model
  // } = {}) => {
  //   const isClozeTypingMath = model?.type === ContentType.CLOZE.type && model.responseFormat === 'math';
  //   const isClozeMath = model?.type === ContentType.CLOZE_MATH.type;
  //   if (!isClozeTypingMath && !isClozeMath) {
  //     return;
  //   }
  //   const userInputMap = questionService.updateUserInputMap({
  //     lessonElementState,
  //     model,
  //     promptAnswerTypeToValidateForPreservation: isClozeMath ? 'cloze' : undefined,
  //     shouldPreserveCorrectUserInputs: true
  //   });
  //   if (userInputMap) {
  //     lessonElementState.currentResponseAnswer.userInputMap = userInputMap;
  //   }
  //   return { lessonElementState };
  // }

  checkForValidResponse = (responseAnswer, model) => {
    if (!responseAnswer?.userInputMap) {
      const userInputMap = questionService.updateUserInputMap({ model, responseAnswer });
      const userInputs = Array.from(userInputMap?.values?.() || []);
      if (userInputs.length === 0) {
        return false;
      }
      return userInputs?.some((userInput) => !!userInput.text);
    } else {
      const userInputs = Array.from(responseAnswer?.userInputMap?.values?.() || []);
      if (userInputs.length === 0) {
        return false;
      }
      return userInputs?.some((userInput) => !!userInput.text);
    }
  }

  isAutoScored = (model) => {
    return questionService.isAutoScored(model);
  }

  // TODO phase out responseAnswer in favor of `lessonElementState.currentResponseAnswer`
  setResponseData = (data = '', _responseAnswer, model, {
    dataId,
    isCustomBlankSection,
    lessonElementState
  } = {}) => {

    if (!lessonElementState.currentResponseAnswer.userInputMap) {
      questionService.updateUserInputMap({ model, lessonElementState });
    } else if (htmlService.isHtmlResponseFormat(model) || isCustomBlankSection) {
      lessonElementState.currentResponseAnswer.userInputMap.set(dataId, {
        dataId,
        text: data
      });
    } else {
      // `responseFormat` is 'text' or 'numeric' and using the native input element
      if (model.responseFormat === 'numeric') {
        if (utilsService.ensureNumericInput(data.target.value)) {
          lessonElementState.currentResponseAnswer.userInputMap.set(dataId, {
            dataId,
            text: data?.target?.value
          });
        }
      } else {
        lessonElementState.currentResponseAnswer.userInputMap.set(dataId, {
          dataId,
          text: data?.target?.value
        });
      }
    }
    lessonManager.stampResponsePublisherTranslationId(lessonElementState?.currentResponseAnswer);
  }

  getCorrectAnswersText = (model) => {
    if (model?.validation?.prompts?.length) {
      let text = '';
      let count = 1;
      for (const modelValidationPrompt of model?.validation?.prompts) {
        const stackHtmlAnswers = model?.type === ContentType.CLOZE_COMBO.type
          && model?.responseFormat === 'html'
          && modelValidationPrompt?.rangeType === 'clozeMultichoice';
        let answerTextBody = (
          modelValidationPrompt?.answers?.filter((answer) => {
            const isCorrectAnswer = promptService.isUserInputAlwaysCorrectIfFoundInModelPromptAnswers(model, modelValidationPrompt) || answer.isCorrect;
            return isCorrectAnswer;
          }).map((answer, index, correctAnswers) => {
            const lastIndex = correctAnswers.length - 1;
            const shouldIncludeComma = !stackHtmlAnswers && index < lastIndex;

            const isTypingPrompt = utilsService.isTypingBlankPrompt(model, modelValidationPrompt);
            let answerSource = answer.text;
            if (answerSource && (model?.type === ContentType.CLOZE_MATH.type || answerSource.includes?.('data-mathml'))) {
              answerSource = clozeMathService.decodeWirisFormulaHtmlToMathMl(answerSource);
            }
            const rawAnswerText = model?.responseFormat === 'image' && typeof answer.altText !== 'undefined'
              ? utilsService.getImageResponseItemHtml(answer)
              : (isTypingPrompt
                ? utilsService.getPlainTextAnswerDisplay(model, answerSource)
                : answerSource);

            const polyfilledAnswerText = rawAnswerText ? htmlService.getPolyfilledHtmlString(rawAnswerText) : '';

            if (!polyfilledAnswerText) {
              return '';
            }
            if (stackHtmlAnswers) {
              return (
                <div key={answer.id} className='answer-html-line'>
                  {parse(polyfilledAnswerText)}
                </div>
              );
            }
            return (
              <span key={answer.id}>
                {parse(`${polyfilledAnswerText}${shouldIncludeComma ? ', ' : ''}`)}
              </span>
            );
          }).filter((answerText) => answerText)
        );
        answerTextBody = answerTextBody.length ? answerTextBody : ['?'];
        text += renderToStaticMarkup(
          <div className='answer-list-row'>
            {model.numberedBlanks && (
              <div className='list-number'>
                {count}
              </div>
            )}
            <div className='correct-icon' />
            <div className='answer-text'>
              {stackHtmlAnswers ? answerTextBody : (
                <span>
                  {answerTextBody}
                </span>
              )}
            </div>
          </div>
        );
        ++count;
      }
      return text;
    }
    return '<div></div>';
  }

  getQuestionFeedbackText = (model, correctFeedback, incorrectFeedback, correctFeedbackBody, incorrectFeedbackBody, mode, _questionIsCorrect, currentAttemptCount, { lessonElementState } = {}) => {
    return questionService.getBehaviorQuestionFeedbackText({
      correctFeedback,
      correctFeedbackBody,
      incorrectFeedback,
      incorrectFeedbackBody,
      mode,
      model,
      questionIsCorrect: lessonElementState.correctAnswerShowing ? QuestionFeedbackState.CORRECT : this.isQuestionCorrect(lessonElementState),
      lessonElementState,
      currentAttemptCount,
      lessonElementId: lessonElementState.lessonElementId
    });
  }

  isQuestionCorrect = (lessonElementState, _lessonElementId) => {
    const _isQuestionCorrect = promptService.getQuestionFeedbackCodeForAllPrompts({ lessonElementState });
    return _isQuestionCorrect;
  }

  isAnswerCorrect = (dataId, lessonElementState, model) => {
    const userInputMap = lessonElementState?.currentResponseAnswer.userInputMap || questionService.updateUserInputMap({
      model,
      responseAnswer: lessonElementState.currentResponseAnswer,
      lessonElementState
    });
    let currentUserInput = userInputMap?.get(dataId);
    if (!currentUserInput && model) {
      const prompts = [...(model.validation?.prompts || []), ...(model.prompts || [])];
      const prompt = prompts.find((item) => item?.id === dataId || item?.blankId === dataId);
      const alternateId = prompt?.id !== dataId ? prompt?.id : prompt?.blankId;
      if (alternateId && alternateId !== dataId) {
        currentUserInput = userInputMap?.get(alternateId);
      }
    }
    
    // For Cloze type questions, check the answerResults array first
    if (lessonElementState?.currentResponseAnswer?.answerResults) {
      const matchingResults = lessonElementState.currentResponseAnswer.answerResults
        .filter(result => result.answerId === dataId && result.match !== undefined);
      if (matchingResults.length) {
        return matchingResults.some(result => result.match);
      }
    }
    
    // Fallback to existing logic for backward compatibility
    // Stripping paragraph tags here so we can trim the string.
    const currentUserInputValue = currentUserInput?.text;

    const result = currentUserInput?.isCorrect || promptService.isCorrectPromptAnswerStatus({
      dataId, currentUserInput, currentUserInputValue, model
    });
    return result;
  }

  setCorrectAnswer = (lessonElementState, model) => {
    const userInputMap = new Map();
    for (const modelValidationPrompt of (model?.validation?.prompts || [])) {
      let answerText;
      if (promptService.isUserInputAlwaysCorrectIfFoundInModelPromptAnswers(model, modelValidationPrompt)) {
        if (lessonManager.playerMode === LessonMode.PRINT_PREVIEW &&
          modelValidationPrompt && modelValidationPrompt.answers &&
          modelValidationPrompt.answers.length > 1) {
          let tempText = '';
          if (model.type === ContentType.CLOZE_MATH.type) {
            for (let i = 0; i < modelValidationPrompt.answers.length; ++i) {
              const decodedAnswer = clozeMathService.decodeWirisFormulaHtmlToMathMl(
                modelValidationPrompt.answers[i].text
              );
              tempText += renderToStaticMarkup(parse(decodedAnswer, {
                replace: (domNode) => {
                  if (domNode.name === 'math') {
                    return <>{domToReact(domNode.children)}</>;
                  }
                }
              }));
              if (i !== modelValidationPrompt.answers.length - 1) {
                tempText += '<mtext>/</mtext>';
              }
            }
            tempText = `<math>${tempText}</math>`;
          } else {
            for (let i = 0; i < modelValidationPrompt.answers.length; ++i) {
              tempText += modelValidationPrompt.answers[i].text;
              if (i !== modelValidationPrompt.answers.length - 1) {
                tempText += '/';
              }
            }
          }
          answerText = tempText;
        } else {
          answerText = modelValidationPrompt?.answers?.[0]?.text || '';
        }
      } else {
        answerText = modelValidationPrompt?.answers?.find((answer) => answer.isCorrect)?.text || '';
      }

      if (answerText && model?.type === ContentType.CLOZE_MATH.type) {
        answerText = clozeMathService.decodeWirisFormulaHtmlToMathMl(answerText);
      }

      if (answerText && model?.responseFormat === 'text') {
        answerText = utilsService.getPlainTextAnswerDisplay(model, answerText);
      }

      if (answerText && ((model && !utilsService.isNullOrEmpty(model.mathText)) || model?.responseFormat === 'math' || model?.type === ContentType.CLOZE_MATH.type)) {
        answerText = htmlService.getPolyfilledHtmlString(answerText);
        answerText = renderToStaticMarkup(parse(answerText, {
          replace: (domNode) => clozeMathService.appendDataIdToMathDomNodeThenConvertToMencloseIfApplicable(domNode, modelValidationPrompt.id, model)
        }));
      }

      let correctAnswer = null;
      if (promptService.isUserInputAlwaysCorrectIfFoundInModelPromptAnswers(model, modelValidationPrompt)) {
        correctAnswer = modelValidationPrompt?.answers?.[0] || null;
      } else {
        correctAnswer = modelValidationPrompt?.answers?.find((answer) => answer.isCorrect) || null;
      }

      if (model?.responseFormat === 'image' && answerText && typeof correctAnswer?.altText !== 'undefined') {
        answerText = utilsService.getImageResponseItemHtml({
          text: answerText,
          altText: correctAnswer?.altText || ''
        });
      }

      const dataId = modelValidationPrompt?.id;
      userInputMap.set(dataId, {
        dataId,
        id: correctAnswer?.id,
        text: answerText || (model.mathText && renderToStaticMarkup(
          clozeMathService.renderClozeMathBlankPlaceholder(dataId, model, '?')
        )) || '',
        ...(typeof correctAnswer?.altText !== 'undefined' ? { altText: correctAnswer.altText || '' } : {}),
        isCorrect: true,
        match: true
      });
    }
    lessonElementState.setCurrentResponse(utilsService.safeMobxClone({
      userInputMap, lessonElementId: model.lessonElementId
    }));
  }

  resetStudentAnswer = (lessonElementState, _validation) => {
    lessonElementState.setCurrentResponse(utilsService.safeMobxClone(lessonElementState.cachedResponseAnswer));
  }

  renderClozeBody = ({
    lessonElementId, lessonElementState, modalBody,
    modalLeft, modalTop, model, renderBlankSection,
    setModalBody, setModalLeft, setModalTop, noSubmit
  } = {}) => {
    return clozeService.renderClozeBody({
      lessonElementId,
      lessonElementState,
      modalBody,
      modalLeft,
      modalTop,
      model,
      renderBlankSection,
      setModalBody,
      setModalLeft,
      setModalTop,
      noSubmit
    });
  }

  _getUserInputText = (value) => {
    if (value == null) {
      return '';
    }
    if (typeof value.text === 'string') {
      return value.text;
    }
    if (typeof value.text?.label === 'string') {
      return value.text.label;
    }
    if (typeof value === 'string') {
      return value;
    }
    return '';
  }

  _getSourceUserInputEntries = (content) => {
    const toEntry = (value, key) => {
      if (!value || typeof value !== 'object') {
        return null;
      }
      const dataId = value.dataId || value.id || key;
      if (!dataId) {
        return null;
      }
      return {
        ...value,
        dataId,
        text: this._getUserInputText(value),
        ...(value.answerId ? { answerId: value.answerId } : {}),
        ...(Array.isArray(value.answerIds) ? { answerIds: value.answerIds } : {}),
        ...(Array.isArray(value.selections) ? { selections: value.selections } : {})
      };
    };

    // The live userInputMap wins when present (in-lesson source). `prompts` is only the
    // saved shape (different-lesson source) or a possibly stale snapshot from an earlier
    // Show Previous Response, which would make q1 -> q2 -> q3 chains pull q1's values.
    const sourceMap = content.userInputMap;
    let mapEntries = [];
    if (sourceMap && typeof sourceMap.forEach === 'function') {
      sourceMap.forEach((value, key) => {
        const entry = toEntry(value, key);
        if (entry) {
          mapEntries.push(entry);
        }
      });
    } else if (sourceMap && typeof sourceMap === 'object' && !Array.isArray(sourceMap)) {
      mapEntries = Object.entries(sourceMap).map(([key, value]) => toEntry(value, key)).filter(Boolean);
    }
    if (mapEntries.length) {
      return mapEntries;
    }

    if (Array.isArray(content.prompts) && content.prompts.length) {
      return content.prompts.map((prompt) => toEntry(prompt, prompt?.dataId || prompt?.id)).filter(Boolean);
    }
    return [];
  }

  _getTargetBlankIds = (model) => {
    if (Array.isArray(model?.prompts) && model.prompts.length) {
      return model.prompts.map((prompt) => prompt.id).filter(Boolean);
    }

    const ids = [];
    const mathText = (model && !utilsService.isNullOrEmpty(model.mathText)) ? model.mathText : '';
    const polyfilledClozeBody = htmlService.getPolyfilledHtmlString((model?.body || mathText || ''));
    parse((polyfilledClozeBody || ''), {
      replace: (domNode) => {
        if (domNode.attribs?.['data-id']) {
          ids.push(domNode.attribs['data-id']);
        }
      }
    });
    return ids;
  }

  _buildUserInputMapFromPreviousContent = (content, model) => {
    const userInputMap = new Map();
    const sourceEntries = this._getSourceUserInputEntries(content);
    const targetIds = this._getTargetBlankIds(model);

    if (targetIds.length) {
      const unusedSources = [...sourceEntries];
      targetIds.forEach((targetId) => {
        const matchingIndex = unusedSources.findIndex((entry) => (
          entry.dataId === targetId || entry.id === targetId
        ));
        const source = matchingIndex >= 0
          ? unusedSources.splice(matchingIndex, 1)[0]
          : unusedSources.shift();
        if (!source) {
          userInputMap.set(targetId, { dataId: targetId, text: '' });
          return;
        }
        userInputMap.set(targetId, {
          ...source,
          id: targetId,
          dataId: targetId,
          text: source.text || '',
          ...(source.answerId ? { answerId: source.answerId } : {})
        });
      });
      return userInputMap;
    }

    sourceEntries.forEach((entry) => {
      userInputMap.set(entry.dataId, entry);
    });
    return userInputMap;
  }

  applyPreviousResponseContent = (lessonElementId, content) => {
    const lessonElementState = responseManager.getLessonElementState(lessonElementId);
    const model = lessonManager.getSlideModel(lessonElementId);
    if (!lessonElementState || !content) {
      return;
    }

    const userInputMap = this._buildUserInputMapFromPreviousContent(content, model);
    const prompts = Array.from(userInputMap.values()).map((entry) => ({
      id: entry.dataId,
      dataId: entry.dataId,
      text: entry.text || '',
      ...(entry.answerId ? { answerId: entry.answerId } : {}),
      ...(Array.isArray(entry.answerIds) ? { answerIds: entry.answerIds } : {}),
      ...(Array.isArray(entry.selections) ? { selections: entry.selections } : {})
    }));

    const { userInputMap: _discardedMap, ...contentRest } = content;
    const cloned = utilsService.safeMobxClone({
      ...contentRest,
      lessonElementId,
      prompts,
      userInputMap,
      responseDependencyAppliedAt: Date.now()
    });
    lessonElementState.setCurrentResponse(cloned);
    lessonManager.stampResponsePublisherTranslationId(lessonElementState.currentResponseAnswer);
  }
}

export default new ClozeBehavior();
